module.exports = __webpack_public_path__ + "static/img/AA6503913.4696675e.jpg";